// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608070504/js/" + chunkId + "." + {"44":"4b166851","225":"da0653d8","481":"a64e79b6","486":"10410082","770":"2a820b34"}[chunkId] + ".0.21517796725952443.chunk.js";
};